import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';

i18n
    .use(XHR)
    .init({
        debug: process.env.NODE_ENV === 'development',

        fallbackLng: 'en_US',
        lng: 'en_US',

        backend: {
            //loadPath: `${process.env.API_URL}/dash_trans/{{lng}}.json`,
            loadPath: `/translation/{{lng}}.json`,
        },

        react: {
            wait: true,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js